document.addEventListener('DOMContentLoaded', function () {
    // We need to get the product variants from a global variable or data attribute
    // Since we are moving this to an external file, we can't use Liquid directly here.
    // We will expect a global variable `productVariants` to be defined in the liquid file before this script runs,
    // OR we can read it from a data attribute on the section.
    // For this refactor, reading from a data attribute is cleaner.

    const productSection = document.querySelector('.product-section');
    if (!productSection) return;

    const productVariants = JSON.parse(productSection.dataset.productVariants || '[]');
    const thumbnails = document.querySelectorAll('.product-thumbnail');
    const mainImage = document.querySelector('.product-main-image img');
    let currentIndex = 0;
    const totalImages = thumbnails.length;

    function updateImage(index) {
        if (index < 0) index = totalImages - 1;
        if (index >= totalImages) index = 0;
        currentIndex = index;

        const thumb = thumbnails[currentIndex];
        if (thumb) {
            const src = thumb.dataset.src;
            if (mainImage) {
                mainImage.src = src;
                mainImage.removeAttribute('srcset'); // Fix: Remove srcset to ensure src update takes effect
            }

            thumbnails.forEach(t => t.classList.remove('active'));
            thumb.classList.add('active');
        }
    }

    thumbnails.forEach((thumb, index) => {
        thumb.addEventListener('click', function () {
            updateImage(index);
        });

        // Preload images
        const src = thumb.dataset.src;
        if (src) {
            const img = new Image();
            img.src = src;
        }
    });

    // Mobile Slider Buttons
    const prevBtn = document.querySelector('.slider-prev');
    const nextBtn = document.querySelector('.slider-next');

    // Use event delegation or direct attachment if elements exist
    if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
            e.preventDefault(); // Prevent form submission if inside form (it's not, but good practice)
            e.stopPropagation();
            updateImage(currentIndex - 1);
        });
    }

    if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            updateImage(currentIndex + 1);
        });
    }

    // Variant Selection Logic
    const variantData = productVariants.map(v => {
        return {
            id: v.id,
            title: v.title,
            options: v.options,
            featured_image: v.featured_image,
            price: v.price,
            compare_at_price: v.compare_at_price
        };
    });

    const variantInputs = document.querySelectorAll('.variant-picker input[type="radio"]');

    function getSelectedOptions() {
        const selected = [];
        document.querySelectorAll('.variant-picker .variant-options').forEach((optionGroup, index) => {
            const checked = optionGroup.querySelector('input:checked');
            if (checked) selected.push(checked.value);
        });
        return selected;
    }

    function updateVariantState() {
        const selectedOptions = getSelectedOptions();
        const matchedVariant = variantData.find(variant => {
            return variant.options.every((option, index) => option === selectedOptions[index]);
        });

        if (matchedVariant) {
            // Update Hidden Input
            const hiddenInput = document.querySelector('.main-product-form input[name="id"]');
            if (hiddenInput) hiddenInput.value = matchedVariant.id;

            // Update Price
            const priceSaleBadge = productSection.querySelector('.price-sale-badge');
            if (priceSaleBadge) {
                const priceSale = priceSaleBadge.querySelector('.price-sale');
                let priceOriginal = priceSaleBadge.querySelector('.price-original');

                if (priceSale) {
                    priceSale.textContent = '$' + (matchedVariant.price / 100).toFixed(2);
                }

                if (matchedVariant.compare_at_price > matchedVariant.price) {
                    if (!priceOriginal) {
                        priceOriginal = document.createElement('span');
                        priceOriginal.classList.add('price-original');
                        priceSaleBadge.appendChild(priceOriginal);
                    }
                    priceOriginal.textContent = '$' + (matchedVariant.compare_at_price / 100).toFixed(2);
                    priceOriginal.style.display = ''; // Ensure visible

                    // Discount Badge Logic
                    let priceSaleMessage = priceSaleBadge.querySelector('.price-sale-message');
                    if (!priceSaleMessage) {
                        priceSaleMessage = document.createElement('span');
                        priceSaleMessage.classList.add('price-sale-message');
                        priceSaleBadge.appendChild(priceSaleMessage);
                    }
                    const discountPercentage = Math.round(((matchedVariant.compare_at_price - matchedVariant.price) / matchedVariant.compare_at_price) * 100);
                    priceSaleMessage.textContent = discountPercentage + '% OFF';
                    priceSaleMessage.style.display = '';

                } else {
                    if (priceOriginal) {
                        priceOriginal.style.display = 'none';
                    }
                    const priceSaleMessage = priceSaleBadge.querySelector('.price-sale-message');
                    if (priceSaleMessage) {
                        priceSaleMessage.style.display = 'none';
                    }
                }
            }

            // Update Image
            if (matchedVariant.featured_image) {

                // Better approach: Loop through thumbnails to find a match by Media ID
                let foundIndex = -1;

                thumbnails.forEach((thumb, index) => {
                    if (thumb.dataset.mediaId == matchedVariant.featured_image.id) {
                        foundIndex = index;
                    }
                });

                if (foundIndex !== -1) {
                    updateImage(foundIndex);
                }
            }
        }
    }

    variantInputs.forEach(input => {
        input.addEventListener('change', function () {
            // Update visual state
            const parent = this.closest('.variant-options');
            parent.querySelectorAll('.variant-option-button, .color-swatch').forEach(l => l.classList.remove('selected'));
            this.closest('label').classList.add('selected');

            updateVariantState();
            updateOptionsAvailability();
        });
    });

    // Linked Options Logic
    function updateOptionsAvailability() {
        const optionGroups = document.querySelectorAll('.variant-picker .variant-options');
        // We use a local copy of selections that we can update on the fly if we auto-correct a selection
        let currentSelections = getSelectedOptions();
        let isDirty = false;

        optionGroups.forEach((group, groupIndex) => {
            const inputs = group.querySelectorAll('input[type="radio"]');

            // 1. Determine valid values for THIS Group (OptionIndex = groupIndex)
            // Valid values are those that exist in variants where ALL PREVIOUS options match currentSelections.
            // (WE DO NOT LOOK AHEAD at future options)

            const validValues = new Set();
            variantData.forEach(variant => {
                // Check if this variant matches all PREVIOUS selections
                let matchPrevious = true;
                for (let i = 0; i < groupIndex; i++) {
                    if (variant.options[i] !== currentSelections[i]) {
                        matchPrevious = false;
                        break;
                    }
                }

                if (matchPrevious) {
                    validValues.add(variant.options[groupIndex]);
                }
            });

            // 2. Toggle Visibility
            inputs.forEach(input => {
                const label = input.closest('label');
                if (label) {
                    if (validValues.has(input.value)) {
                        label.style.display = '';
                    } else {
                        label.style.display = 'none';
                    }
                }
            });

            // 3. Auto-Correct Selection if needed
            // If the currently selected option in this group is now hidden, we MUST switch to a valid one.
            const selectedInput = group.querySelector('input:checked');
            if (selectedInput && !validValues.has(selectedInput.value)) {
                // Current selection is invalid!
                const firstValidValue = Array.from(validValues)[0];
                if (firstValidValue) {
                    const newInput = group.querySelector(`input[value="${firstValidValue}"]`);
                    if (newInput) {
                        newInput.checked = true;
                        // IMPORTANT: Update our local 'currentSelections' so the NEXT loop iteration uses the correct value
                        currentSelections[groupIndex] = firstValidValue;
                        isDirty = true;
                    }
                }
            } else {
                // If it was valid (or nothing selected?), make sure our local state is accurate
                if (selectedInput) {
                    currentSelections[groupIndex] = selectedInput.value;
                }
            }
        });

        // If we auto-corrected any selection, we should trigger a visual update (price, image, etc.)
        if (isDirty) {
            updateVariantState();
        }
    }

    // Swipe Support for Mobile
    const mainImageContainer = document.querySelector('.product-main-image');
    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;
    let touchEndY = 0;

    if (mainImageContainer) {
        mainImageContainer.addEventListener('touchstart', function (e) {
            touchStartX = e.changedTouches[0].screenX;
            touchStartY = e.changedTouches[0].screenY;
        }, { passive: true });

        mainImageContainer.addEventListener('touchend', function (e) {
            touchEndX = e.changedTouches[0].screenX;
            touchEndY = e.changedTouches[0].screenY;
            handleSwipe();
        }, { passive: true });
    }

    function handleSwipe() {
        const xDiff = touchEndX - touchStartX;
        const yDiff = touchEndY - touchStartY;

        // Check if horizontal swipe is dominant and exceeds threshold
        if (Math.abs(xDiff) > 50 && Math.abs(yDiff) < 30) {
            if (xDiff > 0) {
                // Swipe Right -> Prev Image
                updateImage(currentIndex - 1);
            } else {
                // Swipe Left -> Next Image
                updateImage(currentIndex + 1);
            }
        }
    }

    // Initialize
    updateOptionsAvailability();

});
